module.exports = __webpack_public_path__ + "static/img/xiangyoujiantouIcon.a4a30bb9.svg";